module.exports = __webpack_public_path__ + "img/1970East-053_WEB-min.082cdd57.jpg";